var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTigerAngry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_7592)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.411 194.929C169.579 194.096 147.924 151.296 107.778 151.629C79.9593 151.962 57.471 171.614 56.9713 206.254C56.6381 228.404 62.4684 243.226 65.9666 255.383C57.471 254.55 11.6615 252.219 1.16701 278.532C-2.66433 288.358 3.99886 299.849 8.49652 301.015C20.1571 303.346 24.8214 293.854 24.9879 294.02C14.3268 273.036 73.4627 278.532 85.623 281.03C89.4544 281.696 95.4512 278.532 96.2841 277.033C96.2841 277.033 159.085 294.187 192.068 272.037C201.729 265.542 173.244 230.235 180.74 223.407C160.417 199.592 194.566 217.745 173.411 194.929Z",
    fill: "url(#paint0_linear_83_7592)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.262 159.29C137.262 159.29 149.756 179.941 148.423 209.585C151.588 206.421 163.082 179.941 163.915 168.949C158.251 162.288 137.262 159.29 137.262 159.29Z",
    fill: "#9C3D39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M176.408 279.365C176.408 276.867 175.908 274.369 175.408 272.038C172.743 260.38 168.912 248.722 162.415 238.896C155.919 229.07 146.09 221.243 134.93 219.578C123.769 217.912 111.442 223.241 106.111 233.9L103.779 234.566C101.614 249.388 107.777 264.044 113.94 277.7C114.44 278.866 114.94 279.865 115.44 281.031C132.098 283.529 156.418 285.527 176.408 279.365Z",
    fill: "#AD3A34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.251 277.199L159.25 282.862L163.082 282.362L158.251 277.199Z",
    fill: "#9C3D39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.926 261.379C151.421 248.389 152.587 239.063 148.922 232.068C144.091 219.245 126.434 213.416 109.776 219.411C91.4518 224.907 76.4596 241.894 75.127 251.054C73.1281 264.21 106.944 279.699 117.105 287.526C124.601 281.031 126.434 280.698 131.264 275.369L133.93 271.039C135.929 268.207 139.927 264.377 141.926 261.379Z",
    fill: "url(#paint1_linear_83_7592)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 274.035C125.767 271.704 135.095 269.039 142.425 269.039C144.591 269.039 152.92 271.371 154.918 272.869C159.25 277.033 161.249 285.027 160.082 287.525C158.916 290.19 150.587 297.018 142.592 297.351C135.928 297.684 93.2839 291.355 81.7899 290.023C68.9633 288.358 72.7946 279.698 78.1252 269.206L112.441 274.035Z",
    fill: "url(#paint2_linear_83_7592)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.105 293.852C125.102 294.519 130.766 295.351 135.93 295.851C140.927 296.517 145.591 296.184 149.256 294.852C152.921 293.519 155.586 291.521 157.252 290.022C159.084 288.523 159.917 287.69 160.084 287.857C160.25 288.023 159.417 289.023 157.752 290.855C156.086 292.52 153.587 294.852 149.756 296.517C147.923 297.35 145.591 298.016 143.259 298.182C142.093 298.349 140.927 298.349 139.594 298.349C138.262 298.349 137.096 298.182 135.763 298.182C130.599 297.683 124.935 297.183 118.938 296.35C106.945 294.852 96.2836 293.186 88.4544 291.854C84.623 291.188 81.458 290.522 79.2925 289.855C77.1269 289.189 76.1274 288.357 76.1274 288.19C76.1274 288.023 77.2935 288.523 79.459 288.856C81.6246 289.189 84.7896 289.522 88.6209 290.022C96.2836 291.021 107.111 292.354 119.105 293.852Z",
    fill: "#932F30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.087 272.702C152.921 271.203 144.759 269.038 142.593 268.872C130.433 268.039 128.934 272.702 116.773 275.034C116.274 277.032 117.273 279.031 120.105 280.863C124.603 280.53 131.432 281.196 138.928 283.028C152.255 277.365 155.42 273.035 155.087 272.702Z",
    fill: "url(#paint3_linear_83_7592)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.28 239.396C92.452 236.398 80.4582 235.566 72.629 232.068C61.4681 226.906 58.1365 217.413 57.4702 215.914C58.1365 226.24 60.1355 234.733 62.301 242.227C74.2948 246.89 86.9549 244.226 96.6165 245.225C105.445 246.058 109.943 246.224 115.107 249.388C118.105 251.054 111.442 241.728 103.28 239.396Z",
    fill: "#9C3D39"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M114.107 250.22C118.105 253.051 124.601 253.718 127.766 257.215C131.764 255.716 134.763 251.053 137.261 244.225C141.759 232.567 139.927 218.578 124.268 219.577C117.772 219.91 102.113 223.241 90.1193 237.73C78.6253 253.718 106.444 245.058 114.107 250.22Z",
    fill: "#FFF64D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6536 282.03C22.322 292.855 57.4704 293.687 63.1341 293.188C80.2918 291.522 97.1164 288.858 94.4511 269.04C92.119 251.386 100.781 235.898 123.269 253.551C136.429 263.877 132.598 282.696 123.269 294.52C100.948 322.832 52.473 323.331 21.9889 312.007C8.82904 307.177 -5.33025 294.021 2.66559 278.033C5.8306 271.871 10.3283 269.872 16.4917 271.538C21.156 272.703 27.486 276.367 25.6536 282.03Z",
    fill: "url(#paint4_radial_83_7592)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6157 313.338C97.1155 309.175 96.2826 304.512 94.2836 300.848C91.4517 295.352 86.7875 291.688 81.4569 290.189C79.7912 290.689 78.1253 291.189 76.293 291.522C81.4569 292.854 86.2878 295.685 89.2862 300.515C91.7849 304.512 93.2841 310.507 91.6183 315.004C93.2841 314.504 94.9499 313.838 96.6157 313.338Z",
    fill: "#9C3D39"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.945 260.546C101.781 257.048 95.1175 254.883 88.7875 254.883C80.2919 254.883 69.7974 254.55 64.4668 249.721C65.4663 253.551 69.6308 264.376 70.4637 264.709C77.7932 267.041 86.9551 262.544 94.7843 262.211C94.9509 262.211 98.2825 265.375 98.4491 265.375L97.7828 261.378C97.9494 261.212 98.1159 261.212 106.945 260.546Z",
    fill: "#9C3D39"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.436 253.551C100.947 235.898 92.4519 251.386 94.6174 269.04C95.4503 275.368 94.2843 279.865 91.9521 283.195C93.7845 282.696 95.7835 282.363 97.7824 282.363C103.613 282.696 109.443 286.36 111.609 292.022C114.274 298.684 111.442 305.179 106.944 308.343C113.274 304.679 118.938 300.182 123.602 294.354C132.764 282.696 136.596 263.877 123.436 253.551Z",
    fill: "#FFD09C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4838 278.364C34.4822 271.703 32.983 263.376 28.3187 257.88C22.655 259.212 17.1579 261.377 12.4937 264.708C15.3255 264.208 18.4905 264.541 21.1558 265.541C26.3198 267.706 30.3177 272.702 31.4838 278.364Z",
    fill: "#9C3D39"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4689 267.707C62.1347 263.876 62.1347 259.047 60.802 255.05C58.3033 254.883 55.1383 254.883 51.6401 255.05C55.1383 259.546 54.9717 269.872 52.9728 276.7C56.1378 274.368 58.9697 271.537 60.4689 267.707Z",
    fill: "#9C3D39"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4864 284.026C26.9861 283.693 27.4859 283.194 28.1522 282.861C24.3209 274.534 14.4926 269.871 6.33022 272.868C5.16416 273.368 3.99811 273.868 2.83205 274.7C2.16573 275.866 1.49941 277.198 0.999667 278.531C-0.666132 282.694 -0.332972 287.024 0.833087 290.855C1.49941 294.019 2.83205 296.85 4.831 299.515C2.49889 293.852 3.49837 286.525 7.82944 282.361C13.16 277.365 22.1553 278.364 26.4864 284.026Z",
    fill: "#9C3D39"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6483 303.013C37.3146 296.518 43.4781 293.52 47.9758 292.854C44.4776 292.521 40.9794 292.022 37.6478 291.355C32.9836 291.855 28.8191 294.02 26.8201 298.683C24.8212 303.679 25.8206 309.175 26.9867 313.672C31.3178 315.004 35.8154 316.17 40.6462 317.003C37.8144 314.504 36.1486 307.51 36.6483 303.013Z",
    fill: "#9C3D39"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1338 318.834C67.9646 318.834 72.962 318.501 77.7928 317.835C79.7918 314.171 80.6247 300.182 65.7991 293.021C65.2993 293.021 64.9662 293.187 64.4664 293.187C66.4654 301.847 66.4654 310.507 63.1338 318.834Z",
    fill: "#9C3D39"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M123.436 253.551C120.604 251.386 118.105 249.72 115.773 248.555C117.106 249.887 118.105 251.219 119.105 252.885C123.103 260.212 122.603 269.539 119.271 277.199C115.94 284.86 110.109 291.022 103.613 296.351C86.6217 310.008 65.1328 317.502 43.644 317.502C72.1292 321.999 105.945 316.836 123.436 294.52C132.764 282.695 136.596 263.876 123.436 253.551Z",
    fill: "#D87146"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3007 317.668C74.6286 317.335 83.7905 315.67 90.2872 314.005C96.9504 312.506 100.782 311.007 100.948 311.34C101.115 311.673 97.2835 313.671 90.6203 315.67C84.1237 317.668 74.7952 319.667 64.3007 320C53.8062 320.333 44.3111 318.668 37.8145 317.169C31.1513 315.503 27.1534 314.005 27.32 313.671C27.4865 313.338 31.4844 314.338 38.1476 315.503C44.6443 316.503 53.9727 318.001 64.3007 317.668Z",
    fill: "#932F30"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4591 194.263C72.4622 189.266 66.6319 183.771 64.4664 176.609C62.1343 180.939 60.1353 185.936 58.9692 191.431C61.4679 198.926 70.4632 204.421 78.7922 207.253C87.7876 210.417 94.1176 209.917 103.113 215.58C103.779 215.913 107.277 220.076 103.946 214.58C97.4492 204.255 85.4554 200.258 78.4591 194.263Z",
    fill: "#9C3D39"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M117.606 193.43C116.273 183.937 112.942 169.115 105.612 159.123C103.613 156.292 100.615 153.627 98.7823 152.295C93.2852 153.128 88.2878 154.793 83.6235 157.291C85.7891 161.122 90.2867 164.119 93.1186 165.951C107.444 175.277 113.441 188.101 116.606 195.595C117.606 197.927 118.106 196.261 117.606 193.43Z",
    fill: "#9C3D39"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M45.3094 263.71C27.9851 268.873 25.1533 279.698 26.1527 284.528C33.8154 277.7 57.9695 278.199 73.628 279.532C74.4609 277.533 75.7936 275.202 75.9601 274.036C71.4625 266.375 68.464 261.545 68.464 261.545C68.464 261.545 56.6369 260.38 45.3094 263.71Z",
    fill: "#9C5E3C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M147.257 292.688C147.09 293.021 146.091 284.361 146.091 284.361C146.091 284.361 142.093 278.032 142.426 278.032C143.925 279.198 147.423 281.863 147.923 283.195C148.256 284.194 147.423 292.521 147.257 292.688Z",
    fill: "#932F30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M156.586 278.865C157.585 282.196 156.586 289.024 156.419 289.524C156.253 285.86 155.753 281.363 155.253 280.031C154.754 278.699 150.089 273.536 150.089 273.536C150.089 273.536 155.586 277.033 156.586 278.865Z",
    fill: "#932F30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M57.1367 206.254C58.1362 207.586 59.1357 208.586 60.1352 208.919C94.6172 219.411 95.6167 166.118 126.767 158.79C129.766 158.124 130.765 157.291 130.598 156.459C123.769 153.461 116.273 151.629 107.944 151.796C80.1248 151.962 57.6365 171.614 57.1367 206.254Z",
    fill: "#FFF64D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M206.56 270.705C190.068 264.876 174.909 253.884 165.914 245.557C162.916 239.062 157.752 225.239 157.252 222.741C157.252 222.741 148.756 256.216 152.421 268.873C154.087 271.537 166.414 289.523 171.078 291.355C172.744 292.022 190.401 294.686 206.56 297.018V270.705Z",
    fill: "url(#paint5_linear_83_7592)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M210.725 272.203C192.734 266.874 183.572 246.889 173.744 237.896C170.746 231.401 158.085 220.409 157.752 217.911C157.752 217.911 148.757 256.215 152.422 269.039C154.088 271.703 166.414 289.69 171.079 291.522C183.572 300.515 193.567 295.352 210.725 297.85V272.203Z",
    fill: "url(#paint6_linear_83_7592)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M173.41 246.889C170.745 243.725 160.25 238.562 152.254 247.222C155.253 229.069 166.247 227.737 171.744 229.735C177.241 231.734 173.41 246.889 173.41 246.889Z",
    fill: "#9C3D39"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M208.392 297.184C196.898 289.856 198.397 274.202 203.728 269.705C200.063 268.206 196.565 270.871 193.233 269.039C173.243 273.369 172.744 287.025 182.572 296.185C182.905 296.185 189.402 298.183 189.901 298.35C195.399 299.349 203.061 296.352 208.392 297.184Z",
    fill: "#9C3D39"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M154.92 272.704C156.253 274.203 157.585 276.035 159.418 280.032C163.749 285.194 168.579 290.357 171.078 291.19C171.245 291.19 171.411 291.356 171.744 291.356C158.751 275.035 167.413 265.543 185.237 260.547C182.905 259.048 179.907 256.716 177.741 255.051C174.41 255.051 171.245 255.55 168.08 256.883C161.916 259.547 156.752 265.043 153.92 271.871C154.254 272.204 154.587 272.537 154.92 272.704Z",
    fill: "#9C3D39"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M92.7852 285.359C86.6218 291.854 73.4619 294.852 59.4692 294.852C39.6462 294.852 28.9851 290.022 26.653 290.022C20.1564 290.022 36.8144 304.345 60.9684 303.845C76.627 303.512 91.4526 299.348 101.114 291.021C106.112 285.359 94.1179 285.026 92.7852 285.359Z",
    fill: "#FFF68D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M103.447 280.698C110.276 281.531 114.941 272.871 114.941 264.71C114.941 258.715 113.941 250.888 110.11 246.391C97.6162 243.227 92.952 255.551 94.7844 269.04C94.7844 270.04 96.6167 279.699 103.447 280.698Z",
    fill: "#FFF68D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M295.513 135.474C290.349 147.632 290.349 160.455 294.014 172.446L294.18 172.613C297.845 173.279 301.677 171.447 304.675 168.949C307.673 166.451 310.006 163.12 312.171 159.789C315.836 154.626 319.501 148.797 319.501 142.469C319.334 136.973 317.002 130.811 312.837 127.48C306.841 122.651 297.845 129.812 295.513 135.474Z",
    fill: "#FFBF7A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M305.342 171.447C311.172 168.449 316.169 164.119 320.001 158.957C317.335 160.289 314.337 160.955 311.338 160.788C313.837 156.292 314.337 150.796 312.838 145.966C312.005 148.631 310.172 150.796 308.007 152.462C309.34 146.133 308.507 139.471 305.675 133.643C303.842 139.971 300.178 145.633 295.014 149.963C300.677 157.624 304.675 166.617 306.508 175.944L305.342 171.447Z",
    fill: "#FFD6B1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M301.511 120.486C292.515 118.987 284.186 127.148 281.854 136.474C279.522 145.8 281.688 155.959 284.52 165.285L296.18 177.609C298.013 168.783 299.512 159.79 299.512 159.79C304.676 130.812 312.672 130.312 314.837 129.812C311.339 125.482 306.841 121.485 301.511 120.486Z",
    fill: "#87322C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M219.719 111.659C236.044 103.166 256.2 108.662 273.191 102C269.693 105.664 265.362 108.328 260.698 109.494C263.196 109.661 265.695 109.994 268.194 110.16C266.195 113.991 263.863 118.154 259.865 119.653C256.2 120.985 252.035 119.653 248.204 118.654C237.043 115.656 225.216 115.49 214.055 118.154C214.721 117.322 215.388 116.322 216.054 115.49L219.719 111.659Z",
    fill: "#9C3D39"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M286.351 274.035C298.011 269.206 307.506 259.713 315.003 248.222C312.504 246.889 310.338 244.891 310.338 244.891C310.338 244.891 324.164 197.594 308.839 166.451C304.008 156.792 296.845 146.466 288.35 137.307C269.526 117.322 243.706 102.999 219.552 111.326C205.726 115.989 195.232 122.818 186.903 130.978C163.248 153.794 158.417 187.768 155.252 199.259C156.252 213.415 166.08 257.714 209.724 280.031C234.045 286.692 263.863 283.195 286.351 274.035Z",
    fill: "url(#paint7_radial_83_7592)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M186.57 167.616C186.57 167.616 198.564 172.779 206.226 183.937C205.893 174.777 200.563 157.124 196.398 150.796C192.4 144.634 186.57 167.616 186.57 167.616Z",
    fill: "#9C3D39"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M208.891 231.568C193.899 196.261 164.081 177.775 165.247 180.274C165.247 180.274 165.914 176.776 162.249 172.779C160.916 176.61 159.917 180.274 159.084 183.771C175.409 219.743 192.067 230.235 208.891 231.568Z",
    fill: "#9C3D39"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M243.206 283.362C235.71 270.039 225.049 255.217 210.057 247.39C180.072 231.902 172.743 202.591 176.741 178.942L164.747 165.952C159.25 180.108 157.084 193.098 155.418 199.26C156.418 213.416 166.246 257.715 209.89 280.032C220.218 282.863 231.712 283.862 243.206 283.362Z",
    fill: "#9C5E3C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M301.844 240.227C303.343 242.559 305.009 244.89 306.675 247.055C307.841 246.389 309.173 245.723 310.339 244.89C310.506 244.557 316.503 223.407 316.003 200.258C315.337 199.259 314.67 198.426 314.004 197.76C311.006 201.923 305.175 210.75 295.68 217.911C295.181 219.576 294.514 221.075 294.181 222.574C296.68 228.403 298.346 234.565 301.844 240.227Z",
    fill: "#FFB980"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M224.716 223.74C233.045 216.079 243.373 212.749 253.701 213.581C253.535 213.248 253.535 213.082 253.535 212.915C235.044 197.593 231.879 188.6 227.048 180.606C225.383 180.606 223.883 180.773 222.218 181.106C200.229 185.436 204.56 216.246 213.722 243.392L216.221 245.057C215.888 237.23 218.386 229.569 224.716 223.74Z",
    fill: "#FFB980"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M234.379 229.903C231.713 219.744 230.714 209.085 229.381 198.593C229.215 197.594 229.215 196.428 229.048 195.429C227.882 193.93 226.883 192.598 225.883 190.933L224.55 191.432C221.219 192.765 213.723 198.76 212.557 207.087C211.391 216.746 213.889 229.237 217.887 240.894L240.376 247.056C237.877 241.561 235.878 235.732 234.379 229.903Z",
    fill: "#76262C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M223.884 199.925C218.553 203.256 216.721 210.084 217.054 218.577C217.387 226.738 219.719 233.566 224.883 242.059C224.883 242.059 270.193 264.376 257.533 222.741C254.368 212.249 227.049 202.423 223.884 199.925Z",
    fill: "#FDE2E5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M255.201 228.903C253.035 225.572 251.036 221.742 250.203 217.745C245.539 214.747 240.542 212.082 235.378 210.25C233.212 209.418 231.047 208.918 228.881 208.585C226.216 211.916 224.883 216.079 225.216 220.909C225.716 230.235 230.214 238.729 236.377 242.226C236.377 242.226 264.862 265.375 260.365 235.897C258.366 233.732 256.7 231.234 255.201 228.903Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M314.17 222.907C314.003 219.076 312.338 213.747 310.006 211.249C308.173 212.914 306.341 214.746 304.342 216.412V250.885C305.841 250.219 307.34 249.387 308.506 248.554C311.505 241.559 314.67 231.234 314.17 222.907Z",
    fill: "#76262C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M294.347 222.741C292.182 225.905 290.849 229.736 290.516 235.231C291.182 238.895 291.682 241.227 292.848 244.558C293.515 246.723 294.514 249.72 295.847 252.385C297.179 252.552 298.345 252.552 299.678 252.385C302.676 252.052 305.009 251.053 307.341 249.72C310.339 240.228 313.504 225.406 307.341 218.744C304.342 218.744 299.511 217.079 294.347 222.741Z",
    fill: "#FDE0E4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M302.509 223.074C298.344 226.738 294.346 230.735 290.515 234.899C289.515 241.06 290.348 245.89 291.015 248.055C291.681 250.22 294.346 249.887 295.679 252.552C297.012 252.718 298.178 252.718 299.51 252.552C300.676 252.385 301.842 252.052 303.008 251.719C305.341 245.391 309.838 231.568 308.006 222.075C307.839 221.242 307.006 220.743 306.34 221.242C304.841 221.742 303.675 222.408 302.509 223.074Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_7592",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 211,
    width: 39,
    height: 45
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M251.869 214.414C241.208 206.919 224.384 217.411 224.717 223.074C225.217 232.733 229.881 241.393 236.377 245.057C236.377 245.057 263.197 268.539 262.864 245.89C262.697 242.559 262.197 221.741 251.869 214.414Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_7592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.865 224.406C263.531 231.567 261.365 239.061 255.868 241.393C250.371 243.724 243.708 239.728 241.042 232.733C238.377 225.572 240.543 218.077 246.04 215.746C251.537 213.414 258.2 217.411 260.865 224.406Z",
    fill: "url(#paint8_linear_83_7592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.867 225.738C259.699 230.734 258.2 236.064 254.369 237.729C250.537 239.394 245.873 236.563 243.874 231.567C242.042 226.571 243.541 221.242 247.372 219.576C251.204 217.911 256.035 220.742 257.867 225.738Z",
    fill: "#76262C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M247.539 242.391C251.37 240.06 255.035 232.399 253.369 229.568C251.536 226.57 244.707 229.734 240.042 231.233C240.042 231.566 240.042 231.733 240.042 232.066C239.876 236.562 243.041 240.559 247.539 242.391Z",
    fill: "white"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M304.508 234.232C304.341 240.394 301.01 245.391 296.845 245.391C292.681 245.391 289.516 240.228 289.516 233.899C289.682 227.737 293.014 222.741 297.178 222.741C301.343 222.908 304.674 228.07 304.508 234.232Z",
    fill: "url(#paint9_linear_83_7592)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M302.509 234.399C302.509 238.729 300.01 242.227 297.178 242.227C294.346 242.227 292.014 238.563 292.014 234.233C292.014 229.903 294.513 226.405 297.345 226.405C300.177 226.405 302.509 230.069 302.509 234.399Z",
    fill: "#76262C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M296.345 248.721C298.844 242.893 298.511 235.898 296.679 234.066C295.179 232.567 292.681 234.399 290.015 237.064C289.682 238.063 292.181 248.055 296.345 248.721Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M294.347 236.731C295.18 237.397 294.847 239.229 293.681 240.728C293.514 241.061 292.348 242.227 292.182 242.393C291.182 242.06 290.682 240.728 290.183 238.896C290.349 238.563 290.516 238.396 290.682 238.063C291.848 236.564 293.348 236.065 294.347 236.731Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M260.031 292.188C282.853 288.857 308.506 272.203 316.002 248.721C313.17 247.388 310.338 244.89 310.338 244.89C310.338 244.89 305.008 251.385 294.513 252.052C284.185 252.052 278.688 243.058 266.361 238.562C262.863 239.228 261.531 247.055 251.536 248.887C237.876 242.559 217.553 233.233 209.058 231.567C196.731 229.236 188.235 221.575 183.071 216.079C183.071 224.406 189.735 236.397 189.735 236.397C189.735 236.397 183.405 239.395 178.574 233.399C180.739 246.389 187.236 259.712 192.566 268.872C201.395 275.867 212.223 282.029 225.05 286.359C235.711 288.024 249.537 290.356 259.198 292.188C259.365 292.188 259.698 292.188 260.031 292.188Z",
    fill: "url(#paint10_radial_83_7592)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M260.031 292.188C282.853 288.857 308.506 272.204 315.836 248.721C315.669 248.721 315.669 248.555 315.503 248.555C315.336 248.555 315.169 248.388 315.003 248.388C314.836 248.388 314.836 248.222 314.67 248.222C314.503 248.055 314.337 248.055 314.17 247.889C314.003 247.889 314.003 247.722 313.837 247.722C313.837 247.722 313.67 247.722 313.67 247.556C309.339 250.387 297.012 255.05 289.35 255.883C283.519 260.546 281.021 261.212 261.364 278.699C259.199 279.032 249.704 287.525 219.553 270.538C199.73 259.38 188.402 245.391 182.239 236.564C181.905 236.398 181.572 236.231 181.239 236.064C180.906 235.898 180.739 235.731 180.406 235.565C180.406 235.565 180.24 235.565 180.24 235.398C179.907 235.232 179.74 234.899 179.407 234.732L179.24 234.566C178.907 234.233 178.574 233.899 178.241 233.566C178.407 234.899 178.74 236.231 179.074 237.563C179.074 237.73 179.074 237.896 179.24 238.063C179.573 239.395 179.907 240.728 180.24 241.893C180.24 242.06 180.406 242.226 180.406 242.393C180.739 243.725 181.239 245.058 181.739 246.223C181.739 246.39 181.905 246.556 181.905 246.556C182.405 247.889 182.905 249.221 183.405 250.553C183.571 250.72 183.571 251.053 183.738 251.22C184.071 251.886 184.238 252.552 184.571 253.218C184.571 253.385 184.737 253.385 184.737 253.551C184.737 253.718 184.904 253.884 184.904 254.051C185.237 254.717 185.404 255.217 185.737 255.883C185.903 256.049 185.903 256.216 186.07 256.549V256.715C186.903 258.381 187.569 260.046 188.402 261.545C188.569 261.712 188.569 261.878 188.735 262.045C188.735 262.045 188.735 262.211 188.902 262.211C189.235 262.711 189.402 263.377 189.735 263.877C189.901 264.043 189.901 264.21 190.068 264.376L190.234 264.543C190.568 265.042 190.734 265.542 191.067 266.042C191.067 266.208 191.234 266.208 191.234 266.375C191.234 266.541 191.401 266.541 191.401 266.708C191.734 267.374 192.233 268.04 192.567 268.706C193.899 269.705 195.232 270.705 196.565 271.704C197.064 272.037 197.564 272.37 198.064 272.703C198.897 273.369 199.896 273.869 200.896 274.535C201.562 274.868 202.062 275.368 202.728 275.701C203.561 276.2 204.394 276.7 205.227 277.2C206.393 277.866 207.725 278.532 209.058 279.365C209.891 279.864 210.724 280.197 211.557 280.697C212.556 281.197 213.556 281.696 214.722 282.196C215.221 282.529 215.888 282.696 216.388 283.029C217.554 283.528 218.553 284.028 219.719 284.361C220.219 284.527 220.885 284.694 221.385 285.027C222.551 285.527 223.884 285.86 225.05 286.359C235.544 288.025 249.37 290.356 259.032 292.188C259.199 292.188 259.698 292.188 260.031 292.188Z",
    fill: "#F9BD8A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M259.033 292.187C259.366 292.187 259.699 292.187 260.032 292.187C279.855 289.356 301.677 276.366 312.005 257.714C295.68 269.205 271.693 283.527 257.867 289.023C227.716 282.361 199.564 266.54 185.904 256.548C188.07 261.211 190.235 265.374 192.401 268.872C201.23 275.866 212.057 282.028 224.884 286.358C235.545 288.024 249.371 290.355 259.033 292.187Z",
    fill: "#D7805C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M201.395 151.628C202.561 142.802 200.063 134.142 194.899 127.647C189.735 120.985 182.239 116.488 173.91 114.157C167.913 112.492 161.25 111.992 154.92 113.99C146.424 116.822 139.428 124.149 135.763 132.31C129.766 145.466 131.765 160.788 140.76 170.614C148.09 178.608 159.584 182.438 171.078 180.939C173.576 180.606 177.075 180.107 180.573 178.441C188.069 164.951 201.395 151.628 201.395 151.628Z",
    fill: "url(#paint11_linear_83_7592)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M191.567 162.454C188.235 160.122 186.57 157.457 178.74 155.126C168.746 152.128 157.585 153.294 156.252 151.129C160.417 157.957 169.079 161.121 169.579 161.954C158.418 164.119 152.754 167.117 144.092 170.947C152.754 170.614 160.25 172.279 165.081 174.444C163.748 175.444 159.917 177.942 158.584 178.941C168.746 182.938 178.74 180.939 180.573 178.275C183.738 172.612 187.902 167.117 191.567 162.454Z",
    fill: "url(#paint12_linear_83_7592)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M173.91 114.157C167.913 112.492 161.25 111.992 154.92 113.99C146.424 116.822 139.428 124.149 135.763 132.31C133.264 137.972 132.098 143.967 132.431 149.796C134.097 148.131 135.763 146.299 136.596 145.3C146.591 137.639 160.75 137.806 170.911 143.301C179.74 147.964 185.903 155.792 191.067 164.285L201.395 151.795C202.561 142.968 200.063 134.308 194.899 127.813C189.735 121.318 182.239 116.488 173.91 114.157Z",
    fill: "url(#paint13_linear_83_7592)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M263.364 254.383C261.031 250.053 259.865 240.727 260.199 239.561C262.031 236.897 265.196 231.9 271.026 232.9C282.52 234.732 283.187 235.564 287.518 240.561C291.849 245.557 297.679 253.218 297.679 253.218C297.679 253.218 283.02 259.046 274.858 257.548C266.695 255.882 263.364 254.383 263.364 254.383Z",
    fill: "#FE9E2E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M269.527 251.885C269.693 251.885 270.027 252.051 270.36 252.051C271.193 252.218 272.192 252.551 273.025 252.718C275.024 253.217 277.023 253.717 279.022 254.216C279.688 254.383 280.355 254.549 281.021 254.716C281.021 252.218 277.19 246.389 264.363 237.896C263.863 238.395 263.363 239.061 263.03 239.561C265.196 243.558 267.195 247.555 269.027 251.552C269.194 251.718 269.36 251.718 269.527 251.885Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M215.388 112.825C212.056 114.158 209.058 115.49 206.226 116.989L202.228 119.32C201.395 119.82 200.729 120.319 199.896 120.819C212.056 121.485 232.379 127.814 247.538 148.132C247.704 148.465 248.204 148.298 248.204 147.798C242.374 118.321 228.048 113.325 215.388 112.825Z",
    fill: "#9C3D39"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M277.19 173.611C277.356 174.277 278.189 174.111 278.356 173.445C280.355 143.967 272.526 123.15 265.029 118.153C254.702 111.992 243.374 107.828 232.213 108.328C231.547 108.328 227.049 108.994 227.716 109.16C230.214 109.493 233.879 110.493 234.879 110.826C248.538 115.489 265.696 130.477 277.19 173.611Z",
    fill: "#9C3D39"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M288.183 137.139C287.684 136.64 287.017 136.14 286.518 135.641C288.85 141.47 291.348 150.13 291.848 160.788C291.848 161.288 292.348 161.454 292.681 161.121C295.846 156.625 297.345 152.295 298.012 149.13C295.013 145.133 291.848 140.97 288.183 137.139Z",
    fill: "#9C3D39"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M277.022 266.873C277.689 266.873 279.521 266.707 280.854 266.54C284.352 262.377 289.349 259.712 294.347 257.714C294.846 256.881 296.013 255.549 297.678 253.217C293.847 254.882 289.349 255.215 284.685 254.716C276.19 253.883 266.528 250.719 261.031 247.888C261.031 247.888 261.197 253.883 262.697 255.049C269.193 256.881 274.857 260.045 277.522 262.377C277.689 263.709 277.689 265.541 277.022 266.873Z",
    fill: "#76262C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M281.02 266.207C284.518 262.21 289.349 259.546 294.18 257.547C294.68 256.715 295.846 255.382 297.512 253.051C294.513 254.217 294.013 254.383 292.348 254.383C289.016 255.049 280.854 262.544 277.355 266.54C278.022 266.874 279.688 266.54 281.02 266.207Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M298.346 252.552C298.179 252.219 297.679 252.053 297.346 252.219C294.681 253.385 291.516 253.885 288.184 253.885C287.018 253.885 285.852 253.885 284.686 253.718C276.357 252.885 266.695 249.721 261.198 247.057C260.865 246.89 260.532 246.89 260.365 247.057C260.032 247.223 260.032 247.556 260.032 247.889C260.032 247.889 260.032 249.388 260.365 251.053C260.532 251.886 260.699 252.885 260.865 253.552C261.198 254.384 261.365 255.05 262.031 255.717L262.364 255.883C268.528 257.549 273.858 260.546 276.69 262.878C276.69 263.211 276.69 263.544 276.69 263.877C276.69 264.876 276.524 265.709 276.19 266.542C276.024 266.875 276.024 267.208 276.19 267.374C276.357 267.707 276.69 267.874 276.857 267.874C277.69 267.874 279.355 267.707 280.855 267.541C281.021 267.541 281.188 267.374 281.354 267.208C284.686 263.211 289.517 260.546 294.514 258.548L294.847 258.215C295.347 257.382 296.513 256.05 298.179 253.718C298.679 253.385 298.679 252.885 298.346 252.552ZM293.681 256.882C288.851 258.881 284.02 261.545 280.355 265.709C279.689 265.709 278.856 265.875 278.189 265.875C278.356 265.209 278.356 264.543 278.356 263.877C278.356 263.377 278.356 262.711 278.189 262.212C278.189 262.045 278.023 261.712 277.856 261.545C275.024 259.047 269.361 256.05 262.864 254.051C262.697 253.885 262.531 253.552 262.364 252.885C262.031 251.886 261.865 250.554 261.698 249.555C261.698 249.388 261.698 249.222 261.698 249.055C267.528 251.72 276.357 254.551 284.353 255.384C285.519 255.55 286.852 255.55 288.018 255.55C290.516 255.55 292.848 255.217 295.014 254.717C294.681 255.717 294.015 256.383 293.681 256.882Z",
    fill: "#602229"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M306.008 291.522C309.173 291.189 312.504 290.689 314.67 288.025C316.835 285.527 316.002 267.041 307.34 265.209C297.679 267.874 284.019 277.533 278.522 287.525C278.689 288.524 282.52 290.356 287.184 291.023C293.514 291.855 299.844 292.022 306.008 291.522Z",
    fill: "#AD3A34"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M314.336 275.368C314.502 275.201 314.669 275.201 314.836 275.201C313.67 270.538 311.504 266.208 307.506 265.209C301.842 266.874 294.679 270.871 288.683 276.034C301.509 279.698 309.339 278.699 314.336 275.368Z",
    fill: "url(#paint14_linear_83_7592)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M234.711 275.034C234.545 274.867 234.378 274.701 234.211 274.534L234.045 274.368C229.714 271.537 211.557 270.371 205.393 272.369C203.228 273.035 201.229 273.868 199.563 274.534C199.396 274.534 199.23 274.534 198.897 274.534C198.897 274.534 192.566 277.199 187.069 282.362C185.237 284.027 184.404 285.193 184.404 285.193C184.404 285.193 184.571 285.193 184.737 285.193C182.905 288.857 185.404 297.85 187.902 298.682C197.73 301.68 208.891 303.679 213.889 304.345C225.383 304.345 239.209 295.019 240.375 293.52C241.874 291.355 237.876 279.364 234.711 275.034Z",
    fill: "url(#paint15_linear_83_7592)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M234.045 274.202C229.714 271.371 211.557 270.205 205.393 272.203C190.401 276.866 184.404 285.027 184.404 285.027C184.404 285.027 197.398 282.196 207.725 289.19C221.385 287.025 233.379 281.863 235.378 275.867C234.878 275.201 234.545 274.701 234.045 274.202Z",
    fill: "url(#paint16_linear_83_7592)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M196.897 240.56C190.9 234.232 185.403 221.741 183.071 216.246L182.904 216.079C182.904 224.406 189.567 236.397 189.567 236.397C192.233 238.395 194.898 240.061 196.897 240.56Z",
    fill: "#F9BD8A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M277.023 254.383C279.022 255.382 280.688 256.881 280.521 257.714C280.354 258.713 278.689 258.713 276.523 257.714C274.357 256.715 272.858 254.716 273.025 253.884C273.358 252.884 275.024 253.384 277.023 254.383Z",
    fill: "#FEFEFE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M214.055 301.514C199.062 299.682 184.57 296.351 177.907 294.852C188.901 300.015 206.725 303.346 213.721 304.345C225.215 304.345 239.042 295.019 240.208 293.52C240.874 292.687 240.707 290.689 240.041 288.19C238.209 291.022 229.547 299.015 214.055 301.514Z",
    fill: "#932F30"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M223.384 296.518C223.384 296.851 216.887 287.858 216.887 287.858C216.887 287.858 212.223 283.528 212.723 283.528C214.555 284.194 219.219 285.194 220.052 286.359C220.552 287.026 223.384 296.185 223.384 296.518Z",
    fill: "#932F30"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M230.714 280.696C231.88 283.195 231.547 289.69 231.547 290.023C231.047 287.025 229.215 283.361 228.715 282.195C228.215 281.196 224.217 277.865 224.217 277.865C224.217 277.865 229.714 279.531 230.714 280.696Z",
    fill: "#932F30"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M314.669 288.024C314.836 287.857 315.002 287.524 315.169 287.025C303.342 289.19 290.515 287.025 286.184 285.359C285.351 284.194 285.351 281.196 285.684 278.531C282.852 281.362 280.52 284.194 278.688 287.191C278.855 288.191 282.686 290.022 287.35 290.689C293.514 291.521 299.844 291.688 306.174 291.188C309.172 291.188 312.504 290.522 314.669 288.024Z",
    fill: "#932F30"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M305.34 270.704C305.34 270.704 306.84 278.365 306.84 279.031C306.84 279.697 307.173 286.525 307.173 286.525C307.173 286.525 310.837 279.531 310.837 278.365C310.837 277.199 305.34 270.704 305.34 270.704Z",
    fill: "#932F30"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M295.846 272.703L297.012 277.699L295.513 286.026L293.68 278.032L295.846 272.703Z",
    fill: "#932F30"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M267.695 191.598C268.195 196.927 267.195 201.424 263.53 206.42C253.536 198.926 240.875 189.766 240.875 189.766C240.875 189.766 253.702 187.102 267.695 191.598Z",
    fill: "#9C3D39"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M297.345 196.927C297.345 196.927 297.678 203.089 296.179 210.084C300.177 208.585 308.672 203.589 310.671 197.927C303.342 196.261 297.345 196.927 297.345 196.927Z",
    fill: "#9C3D39"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M257.032 277.366C259.697 277.199 265.195 277.199 266.527 277.865C267.027 278.199 270.192 274.368 269.359 274.368C268.693 274.368 263.695 275.034 259.031 276.367C256.866 276.866 256.366 277.532 257.032 277.366Z",
    fill: "#76262C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M214.221 117.987C193.066 133.309 238.875 168.615 284.185 181.772C329.495 194.928 281.186 128.979 260.031 119.653C238.709 110.326 221.551 112.658 214.221 117.987Z",
    fill: "#FFF64D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M246.705 233.066C247.038 234.565 245.372 236.064 243.207 236.73C240.875 237.23 238.876 236.564 238.543 235.231C238.209 233.732 239.875 232.234 242.041 231.567C244.373 230.901 246.538 231.734 246.705 233.066Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M223.883 199.925C223.883 200.424 247.538 215.912 260.697 219.243C258.365 216.412 256.866 214.081 256.866 214.081C256.866 214.081 236.543 204.588 226.049 191.265C219.386 193.929 223.883 199.925 223.883 199.925Z",
    fill: "#76262C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M293.181 224.407C293.181 224.407 307.34 219.91 309.339 217.245C310.505 217.245 310.005 211.583 310.005 211.583C310.005 211.583 301.676 216.579 294.68 220.077C294.18 221.742 293.181 224.407 293.181 224.407Z",
    fill: "#76262C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_7592",
    x1: 66.7932,
    y1: 164.153,
    x2: 92.1462,
    y2: 252.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00096858,
    stopColor: "#FE9128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    stopColor: "#FE8B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5904,
    stopColor: "#FE7B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9632,
    stopColor: "#FF613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#FF5E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_7592",
    x1: 130.937,
    y1: 230.09,
    x2: 93.5791,
    y2: 270.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#FF5E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_83_7592",
    x1: 117.676,
    y1: 274.153,
    x2: 116.127,
    y2: 293.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2993,
    stopColor: "#EA5539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9137,
    stopColor: "#B53E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD3A34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_83_7592",
    x1: 149.629,
    y1: 281.875,
    x2: 130.124,
    y2: 273.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00096858,
    stopColor: "#FE9128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    stopColor: "#FE8B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5904,
    stopColor: "#FE7B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9632,
    stopColor: "#FF613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#FF5E3B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_83_7592",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.347 237.795) scale(69.5535 72.4683)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00096858,
    stopColor: "#FE9128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    stopColor: "#FE8B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5904,
    stopColor: "#FE7B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9632,
    stopColor: "#FF613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#FF5E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_83_7592",
    x1: 147.716,
    y1: 245.603,
    x2: 200.662,
    y2: 282.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2993,
    stopColor: "#EA5539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9137,
    stopColor: "#B53E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD3A34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_83_7592",
    x1: 159.042,
    y1: 227.351,
    x2: 193.523,
    y2: 293.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3669,
    stopColor: "#EA5539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE4136"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_83_7592",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254.768 148.255) scale(86.8016 90.7203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00371466,
    stopColor: "#FFA83A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2074,
    stopColor: "#FFA23A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4711,
    stopColor: "#FF923A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7665,
    stopColor: "#FF783B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#FF5E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_83_7592",
    x1: 243.287,
    y1: 237.391,
    x2: 258.391,
    y2: 220.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9894,
    stopColor: "#AE1702"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_83_7592",
    x1: 291.629,
    y1: 240.833,
    x2: 301.534,
    y2: 229.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9894,
    stopColor: "#AE1702"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_83_7592",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(272.878 247.884) scale(43.2765 45.2302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0127592,
    stopColor: "#FFF6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2932,
    stopColor: "#FFE6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5589,
    stopColor: "#FFDAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8015,
    stopColor: "#FFD2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD09C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_83_7592",
    x1: 200.697,
    y1: 154.76,
    x2: 138.355,
    y2: 140.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#FFB96D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_83_7592",
    x1: 136.039,
    y1: 166.208,
    x2: 221.41,
    y2: 166.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1899,
    stopColor: "#FFE8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#FFC591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_83_7592",
    x1: 153.758,
    y1: 127.616,
    x2: 187.366,
    y2: 164.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76262C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    stopColor: "#7C2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4096,
    stopColor: "#8C352C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6697,
    stopColor: "#A7482D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9492,
    stopColor: "#CB622E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3672E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_83_7592",
    x1: 305.701,
    y1: 284.115,
    x2: 300.303,
    y2: 271.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00096858,
    stopColor: "#FE9128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    stopColor: "#FE8B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5904,
    stopColor: "#FE7B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9632,
    stopColor: "#FF613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#FF5E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_83_7592",
    x1: 175.6,
    y1: 218.915,
    x2: 209.911,
    y2: 284.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3669,
    stopColor: "#EA5539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_83_7592",
    x1: 216.413,
    y1: 295.55,
    x2: 208.092,
    y2: 276.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00096858,
    stopColor: "#FE9128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    stopColor: "#FE8B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5904,
    stopColor: "#FE7B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9632,
    stopColor: "#FF613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#FF5E3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_7592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 218,
    fill: "white",
    transform: "translate(0 102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTigerAngry);
export default __webpack_public_path__ + "static/media/tiger_angry.19ddaf45d05090b268564ade52cd4f8e.svg";
export { ForwardRef as ReactComponent };